export type ChannelTrafficType = 'ftd' | 'std' | 'td';
export const channelTrafficTypes: ChannelTrafficType[] = ['ftd', 'std', 'td'];
const channelMethods: Record<string, string[]> = {
    KGS: ['card', 'sbp_kgs', 'elqr'],
    KZT: ['kzt_transgran_gel', 'kzt_transgran_tjs', 'kzt_transgran_idr', 'kzt_transgran_uzs'],
};
export const supportsPaymentChannels = (currency: string): boolean => Boolean(channelMethods[currency]);

export const paymentChannelName = (method: string, traffic: string | null | undefined, currency: string): string => {
    const base = currency === 'KGS' && method === 'sbp' ? 'sbp_kgs' : method;
    const providerMethod = base.replace('kzt_transgran_with_comission_', 'kzt_transgran_');
    if (!channelMethods[currency]?.includes(providerMethod) || !channelTrafficTypes.includes(traffic as ChannelTrafficType)) {
        return method;
    }
    return `${base}_${traffic === 'td' ? 'trusted' : traffic}`;
};
